import { StyledTouchIcon, StyledMobileHint } from './MobileHint.styles';
import { MobileHintProps } from './MobileHint.types';

export const MobileHint = ({ isMobile }: MobileHintProps) => {
  if (!isMobile) {
    return <></>;
  }
  return (
    <StyledMobileHint component="span">
      <StyledTouchIcon />
      Натисніть та утримуйте для переміщення
    </StyledMobileHint>
  );
};
